<template>
  <nav>
    <v-layout wrap>
        <v-toolbar dark app color="#232323">
            <v-toolbar-side-icon class="hidden-md-and-up" @click="toggleDrawer" />
                <v-toolbar-title class="headline text-uppercase">  
                    <a href="/" class="brand font-weight-bold white--text"> Maria Danishvar<span class="title-three font-weight-bold grey--text hidden-sm-and-down"> |  Soprano</span> </a>
                    <!-- <span class="title-three font-weight-light">&nbsp;&nbsp;&nbsp; | <v-icon right>phone</v-icon> 44 (0) 7402 890775</span> -->
                </v-toolbar-title>

        <v-spacer></v-spacer> 

        <v-btn  class="menu-btn hidden-sm-and-down text-uppercase" 
                flat 
                v-for="link in links" 
                :key="link.text" 
                router
                :to="link.href">
            <span>{{ link.text }}</span>
        </v-btn>

        <v-dialog v-model="dg_contscts" width="500">
            <template v-slot:activator="{ on }">
                <v-btn flat v-on="on">Contacts</v-btn>
            </template>
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>Maria Danishvar</v-card-title>
              <v-card-text>
                <v-layout row align-center justify-center fill-height>
                  <v-flex xs12>
                    <v-card class="mt-2">
                        <v-card-text class="px-5">
                          <p class="subheading">masha_danishvar @ hotmail .co .uk</p>  
                          <p class="subheading">+44 (0) 7402 890775</p>
                      </v-card-text>  	
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="dg_contscts = false" >
                  Ok
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      <Drawer :drawer="drawer" />
    </v-layout>
  </nav>
</template>

<script>
  import links from '@/data/links.json'
  import Drawer from '@/components/Drawer'
  export default {
    name: 'Header',
    components: {
      Drawer
    },
  data () {
    return {
      dg_contscts: false,
      dg_gallery: false,
      drawer: false,
      links: []
    }
  },
  created(){
    this.getLinks()
  },
  methods: {
      getLinks(){
        this.links = links
      },
      toggleDrawer() {
        this.drawer = !this.drawer
      }
    }
}
</script>

<style>
  .menu-btn {
      font-family: 'Open Sans Condensed', sans-serif!important;
      color: #969595!important;
      font-size: 14px!important;
      font-weight: normal!important;
    }
    .gal-menu {
      margin-top: 120px;
    }
     @media (max-width: 473px) {
        .brand {
            font-size: 20px!important;
        }
    }
    @media (min-width: 1085px) {
        .brand {
            font-size: 16px!important;
        }
    }
    a#navbar-brand {
        font-family: 'Open Sans Condensed', sans-serif!important;
        display: inline-block;
    }
</style>